/**
 * Rewrite agentic-backend file URLs through the same-origin /proxy/workflow
 * path so browser fetch() works on hosts that aren't in the backend CORS
 * allowlist (e.g. Vercel PR previews). Raw S3 URLs are left unchanged.
 */
export function toSameOriginWorkflowUrl(url: string): string {
  if (!url) return url;
  try {
    const parsed = new URL(url);
    const path = parsed.pathname;
    if (
      path === '/files/download' ||
      path.startsWith('/files/download/') ||
      path.startsWith('/s3/proxy/')
    ) {
      return `/proxy/workflow${path}${parsed.search}`;
    }
  } catch {
    // Relative or invalid URL — use as-is
  }
  return url;
}
